/*
  Bloom article progressive enhancement.
  Builds the table of contents from the H2s in the rendered body so authors
  never maintain it by hand. Server-rendered content is untouched — this only
  adds anchor ids + a nav that's hidden until it has 2+ entries.
*/
(() => {
  const body = document.querySelector('[data-bloom-article-body]');
  const toc = document.querySelector('.bloom-article__toc');
  if (!body || !toc) return;

  const list = toc.querySelector('.bloom-article__toc-list');
  const headings = body.querySelectorAll('h2');
  if (!list || headings.length < 2) return;

  const slugify = (text, i) => {
    const base = text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return base ? `${base}-${i}` : `section-${i}`;
  };

  const frag = document.createDocumentFragment();
  headings.forEach((h, i) => {
    if (!h.id) h.id = slugify(h.textContent, i);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent;
    li.appendChild(a);
    frag.appendChild(li);
  });

  list.appendChild(frag);
  toc.hidden = false;
})();
